// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"_6351a822","additionalBlur":"_e071aa11","isNarrow":"_ac0ca3ec"};